import { connect } from 'react-redux';
import { actions as campaignActions } from '~/campaign';
import { campaignsPage, goTo } from '~/routes';
import { actions } from './reducer';
import CampaignForm from './components/CampaignForm';

export default connect(
  (state, ownProps) => {
    return {
      campaign: state.campaignForm.campaign,
      isLoading: state.campaignForm.isLoading,
      editMode: ownProps.editMode,
      campaignId:
        ownProps?.match?.params?.id || state?.campaignForm?.campaignId,
      hasCampaignsFlip: state.organizations.selected?.hasCampaignsFeature,
    };
  },
  (dispatch, ownProps) => ({
    onCancelClick: () => {
      const fromPath = ownProps.history.location?.state?.from;
      if (fromPath) {
        dispatch(goTo(fromPath));
      } else {
        dispatch(campaignsPage.goTo());
      }
    },
    onCreateOrUpdateCampaignClick: ({
      campaignId,
      colorSelected,
      campaignName,
      orgId,
      editMode,
    }) => {
      if (editMode) {
        dispatch(
          actions.handleEditCampaignClick({
            id: campaignId,
            name: campaignName,
            color: colorSelected,
            orgId,
          })
        );
      } else {
        dispatch(
          actions.handleCreateCampaignClick({
            name: campaignName,
            color: colorSelected,
          })
        );
      }
    },
    fetchCampaign: ({ campaignId }) => {
      dispatch(campaignActions.fetchCampaign({ campaignId }));
    },
  })
)(CampaignForm);

export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
